// extracted by mini-css-extract-plugin
export default {"qrCodeContainer":"QRModal_qrCodeContainer__JkBlD","qrCode":"QRModal_qrCode__viJ0u","label":"QRModal_label__aM6NE"};